"use client";

import { useLocale } from "@/lib/i18n";
import type { Dict } from "@/lib/i18n";

type Key = keyof Dict["caseStudy"];

/**
 * Tiny i18n hook for case-page chrome — replaces hard-coded EN labels with
 * dictionary-aware labels. SSR renders EN canonical (since LocaleProvider
 * defaults to "en"); on hydration the active locale's label takes over.
 */
export function CaseLabel({ kw }: { kw: Key }) {
  const { t } = useLocale();
  return <>{t.caseStudy[kw]}</>;
}

export function CaseBodyLanguageNote() {
  const { t, locale } = useLocale();
  if (locale === "en" || !t.caseStudy.bodyLanguageNote) return null;
  return (
    <div className="mt-5 inline-flex items-center gap-2 microcaps text-[10px] text-[var(--color-text-mute)] px-2.5 py-1 rounded-sm border border-[var(--color-hairline)]">
      <span aria-hidden className="block h-1.5 w-1.5 rounded-full bg-amber-400" />
      {t.caseStudy.bodyLanguageNote}
    </div>
  );
}
